import { js_utils } from "../utils/frfr-js-utils";
import { lib_ter_cparams_cache_get, lib_ter_document_cache_get, lib_ter_virtel_params_cache_get, ter_sifrarnik_jedinice_cache_get, ter_sifrarnik_operacije_cache_get, ter_sifrarnik_radni_centri_cache_get } from "./ter-cache-utils";
// import { terLibVirtelParametri, terLibParametriMaterijaliPrvi } from "./ter-params-lib"; // parametri iz biblioteke
// import { terLibParametriMaterijaliPrvi } from "./ter-params-lib"; // parametri iz biblioteke


export const _getParamsFromLib = (element_key) => {
  // get virtel params
  let params = {};
  const terLibSifrarnikJedinice = ter_sifrarnik_jedinice_cache_get(); // koristimo keširane podatke
  const terLibVirtelParametri = lib_ter_virtel_params_cache_get(); // koristimo keširane podatke
  if (js_utils.is_object(terLibVirtelParametri[element_key])) {
    params = {
      ...terLibVirtelParametri[element_key]
    };
    if (params["jm"]) {
      // u slucaju da se trazi parametar koji kao value ima KEY za SPISAK sa kojeg se uzima
      params["jm"] = terLibSifrarnikJedinice[params["jm"]];
    } /* else if (params["operacija"]) {
      // u slucaju da se trazi parametar koji kao value ima KEY za SPISAK sa kojeg se uzima
      params["operacija"] = terLibSifrarnikOp[params["operacija"]];
    } else if (params["rc"]) {
      // u slucaju da se trazi parametar koji kao value ima KEY za SPISAK sa kojeg se uzima
      params["rc"] = terLibSifrarnikRadniCentri[params["rc"]];
    } */
  }
  return params;
};

export const _getParamSingleFromLib = (element_key, param_key) => {
  const terLibSifrarnikJedinice = ter_sifrarnik_jedinice_cache_get(); // koristimo keširane podatke
  const terLibVirtelParametri = lib_ter_virtel_params_cache_get(); // koristimo keširane podatke
  if (js_utils.is_object(terLibVirtelParametri[element_key])) {
    let param_val = terLibVirtelParametri[element_key][param_key];
    if (param_key === "jm") {
      // u slucaju da se trazi parametar koji kao value ima KEY za SPISAK sa kojeg se uzima
      return terLibSifrarnikJedinice[param_val];
    } /* else if (param_key === "operacija") {
      // u slucaju da se trazi parametar koji kao value ima KEY za SPISAK sa kojeg se uzima
      return terLibSifrarnikOp[param_val];
    } else if (param_key === "rc") {
      // u slucaju da se trazi parametar koji kao value ima KEY za SPISAK sa kojeg se uzima
      return terLibSifrarnikRadniCentri[param_val];
    } */
    return param_val;
  }
};

export const _getParamSingleFromSifrarnikOp = (param_key) => {
  const terLibSifrarnikOp = ter_sifrarnik_operacije_cache_get(); // koristimo keširane podatke
  // return terLibSifrarnikOp[param_key];
  if (param_key in terLibSifrarnikOp) {
    return terLibSifrarnikOp[param_key];
  } else {
    // okoliko sifra nije pronadjena u sifrarniku zadrzavamo sifru neizmenjenu
    return param_key;
  }
};
export const _getParamSingleFromSifrarnikRadnicentri = (param_key) => {
  const terLibSifrarnikRadniCentri = ter_sifrarnik_radni_centri_cache_get(); // koristimo keširane
  // return terLibSifrarnikRadniCentri[param_key];
  if (param_key in terLibSifrarnikRadniCentri) {
    return terLibSifrarnikRadniCentri[param_key];
  } else {
    // okoliko sifra nije pronadjena u sifrarniku zadrzavamo sifru neizmenjenu
    return param_key;
  }
};

export const _getParamSingleFromSifrarnikOp_key_smart = (param_key) => {
  const terLibSifrarnikOp = ter_sifrarnik_operacije_cache_get(); // koristimo keširane podatke
  const param_val = terLibSifrarnikOp[param_key];
  if (typeof param_val === 'string') {
    // primili smo param_key returnujemo isto
    return param_key;
  } else {
    // primili smo param_val returnujemo param_key
    const _param_val = param_key;
    let _param_key;
    Object.keys(terLibSifrarnikOp).forEach((key) => {
      if (terLibSifrarnikOp[key] === _param_val) {
        _param_key = key;
      }
    });
    return _param_key;
  }
};
export const _getParamSingleFromSifrarnikRadnicentri_key_smart = (param_key) => {
  const terLibSifrarnikRadniCentri = ter_sifrarnik_radni_centri_cache_get(); // koristimo keširane
  const param_val = terLibSifrarnikRadniCentri[param_key];
  if (typeof param_val === 'string') {
    // primili smo param_key returnujemo isto
    return param_key;
  } else {
    // primili smo param_val returnujemo param_key
    const _param_val = param_key;
    let _param_key;
    Object.keys(terLibSifrarnikRadniCentri).forEach((key) => {
      if (terLibSifrarnikRadniCentri[key] === _param_val) {
        _param_key = key;
      }
    });
    return _param_key;
  }
};


/*
export const _getParamSingleFromParametriMaterijaliPrvi = (id, param_key) => {
  // TODO ovaj da se prebaci na pravu bazu bibliteku...
  if (terLibParametriMaterijaliPrvi[id] && terLibParametriMaterijaliPrvi[id][param_key]) {
    return terLibParametriMaterijaliPrvi[id][param_key];
  } else {
    return ("* ERROR " + id + " " + param_key);
  }
};
*/


// NOVO VENTILATORI
export const _getEntityFromLibDocument = (element_key) => {
  // na primer "TER_TABELA_VENTILATORA"
  let doc = {};
  const terLibDocument = lib_ter_document_cache_get(); // koristimo keširane podatke
  // console.log('terLibDocument', terLibDocument);
  if (js_utils.is_object(terLibDocument[element_key])) {
    doc = {
      ...terLibDocument[element_key]
    };
  }
  return doc;
};
export const _getDocumentTabelaVentilatoraFromLib = () => {
  //
  const lib_entity_key = "TER_TABELA_VENTILATORA";
  const doc = _getEntityFromLibDocument(lib_entity_key); // koristimo keširane podatke
  return doc;
};
export const _getVentilatorSingleFromLib = (ventilator_key) => {
  // na primer "ER28C"
  const lib_entity_key = "TER_TABELA_VENTILATORA";
  const doc = _getEntityFromLibDocument(lib_entity_key); // koristimo keširane podatke
  if (js_utils.is_object(doc) && doc[ventilator_key]) {
    let ventilator_obj = doc[ventilator_key];
    return ventilator_obj;
  }
  //
  return {}; // TODO ???
};


//
export const _getEntityFromLibCparams = (element_key) => {
  // na primer "TERKK_CPARAMS_DEFAULT"
  let entity = null;
  const terLibCparams = lib_ter_cparams_cache_get(); // koristimo keširane podatke
  console.log('terLibCparams', terLibCparams);
  if (js_utils.is_object(terLibCparams[element_key])) {
    entity = {
      ...terLibCparams[element_key]
    };
  }
  return entity;
};
export const _getTerkkCparamsDefaultFromLib = () => {
  //
  let terkk_cparams_default = null;
  const lib_entity_key = "TERKK_CPARAMS_DEFAULT";
  const entity = _getEntityFromLibCparams(lib_entity_key); // koristimo keširane podatke
  if (js_utils.is_object(entity) && js_utils.is_object(entity.cparams_obj)) {
    terkk_cparams_default = entity.cparams_obj;
  }
  return terkk_cparams_default;
};

